<template>
    <div
        :for="value"
        class="hslp-package d-block rounded float-none cursor-pointer font-size-5 h-100 p-4 m-0"
        :class="{ 'selected': selected === value }"
    >
        <div>
            <b-form-radio
                class="d-none"
                name="packages"
                :id="value"
                :value="value"
                :checked="selected"
                @input="$emit('input', $event)"
            />

            <div class="text-gray-dark text-left">
                No Protection
            </div>

            <div>
                <b-row align-h="center">
                    <b-col cols="8">
                        <b-img
                            class="mb-3"
                            fluid
                            :alt="iconAlt"
                            :src="iconSrc"
                        />
                    </b-col>
                </b-row>

                <h4 class="text-gray-dark text-center mb-0">
                    No Protection
                </h4>

                <p>$0 in legal protection against lawsuits</p>

                <p>Forms included</p>

                <p>If legal issues arise after the sale, I will engage and pay my own legal team.</p>

                <div class="mb-2">
                    <b-button
                        variant="secondary"
                        class="pt-2 no-protection-button"
                        size="sm"
                        block
                        @click="clickNoProtectionButton"
                    >
                        No Protection
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoProtection',
    props: {
        value: {
            type: String,
            required: true,
        },
        selected: {
            type: String,
            required: true,
        },
        iconSrc: {
            type: String,
        },
        iconAlt: {
            type: String,
        },
    },
    model: {
        prop: 'selected',
    },
    methods: {
        clickNoProtectionButton() {
            this.$emit('click-no-protection-button');
        }
    }
}
</script>
